export type PersonFormProps = {
    privateCustomerNumber: string;
    dateOfBirth: string;
    confirmTermsAndConditions: boolean;
    confirmPrivacyPolicy: boolean;
};

export type BusinessFormProps = {
    businessCustomerNumber: string;
    dateFounded: string;
    confirmTermsAndConditions: boolean;
    confirmPrivacyPolicy: boolean;
};

export enum CustomerType {
    PRIVATE = 'PRIVATE',
    BUSINESS = 'BUSINESS',
}
